module.exports = __webpack_public_path__ + "static/img/ats-chart.18ba3bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ats-chart.svg
// module id = iTsA
// module chunks = 0